module.exports = __webpack_public_path__ + "img/jeju43-logo.e6c7d524.png";